import $ from 'jquery';
import header from './header';
import imagecarousel from './image-carousel';
import smoothScroll from './smooth-scroll';
import accordion from './accordion';
import tabs from './tabs';
import AOS from 'aos';
import testimonials from './solutions-carousel';
import clienttestimonials from './testimonials';


$(document).ready(function () {
    AOS.init({
        once: true,
    });
});
